import React, { useMemo, useState } from "react";
import Navbar from "./components/navbar";
import Sidebar from "./components/sidebar";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import Drawer1 from "./components/drawer";

const Layout = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const role = localStorage.getItem("role");
  const adminMenu = [
    { label: "Dashboard", link: "/dashboard" },
    { label: "Customers", link: "customers" },
    { label: "Assets", link: "assets" },
    { label: "Schemes", link: "schemes" },
    { label: "Users", link: "users" },
    { label: "Area", link: "area" },
    { label: "Maps", link: "maps" },
    { label: "Trash", link: "trash" },
    { label: "Reports", link: "reports" },
    { label: "Logout", link: "/logout" },
  ];

  const employeeMenu = [
    { label: "Dashboard", link: "/dashboard" },
    { label: "Customers", link: "customers" },
    { label: "Assets", link: "assets" },
    { label: "Area", link: "area" },
    { label: "Trash", link: "trash" },
    { label: "Reports", link: "reports" },
    { label: "Logout", link: "/logout" },
  ];

  const agentMenu = [
    { label: "Dashboard", link: "/dashboard" },
    { label: "Customers", link: "list" },
    { label: "Payments", link: "paymentslist" },
    { label: "Assets", link: "assetlist" },
    { label: "Maps", link: "maps" },
    { label: "Logout", link: "/logout" },
  ];
  const defaultMenu = [{ label: "Login", link: "/login" }];
  const menuItems = useMemo(() => {
    switch (role) {
      case "admin":
        return adminMenu;
      case "employee":
        return employeeMenu;
      case "agent":
        return agentMenu;
      default:
        return defaultMenu;
    }
  }, [role]);
  return (
    <Box sx={{ display: "flex", height: "100dvh", overflow: "hidden" }}>
      {/* Sidebar - visible on large screens */}
      <Box
        sx={{
          maxWidth: { xs: 0, md: 250 },
          minWidth: { xs: 0, md: 250 },
          display: { xs: "none", md: "block" },
          backgroundColor: "#FEDDDD",
          // boxShadow: "2px 0 4px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Sidebar menuItems={menuItems} />
      </Box>

      {/* Main Content Area */}
      <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
        {/* Navbar */}
        <Box
          sx={{
            display: { xs: "block", sm: "none" },
            height: "100px",
            backgroundColor: "#FEDDDD",
            // borderBottom: "1px solid #444",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            zIndex: 10,
          }}
        >
          <Navbar setDrawerOpen={setDrawerOpen} />
        </Box>

        {/* Outlet */}
        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            backgroundColor: "#FFF5F5",
            p: 2, // Add padding to content if needed
          }}
        >
          <Outlet />
        </Box>
      </Box>
      <Drawer1
        menuItems={menuItems}
        isOpen={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      />
    </Box>
  );
};

export default Layout;
